<template>
  <div class="general-page">
    <template v-if="!sent">
      <h1>Get a Login Link</h1>

      <p>We'll email you a secure link you can use to instantly access your account.</p>

      <div class="qform2022 full">
        <p
          v-if="first(errors) || errors.recaptcha_response"
          class="notice error live"
        >
          <span class="icon-attention redicon" />
          {{ first(errors) }}
        </p>

        <form
          class="login-form"
          @submit.prevent="post"
        >
          <div class="generic-inputs">
            <label>Email address*</label>
            <input
              v-model="email"
              type="text"
              name="email_address"
              placeholder="Email Address"
            >
          </div>

          <div v-if="recaptchaFields.required">
            <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaKey"
              @verify="recaptchaCompleted"
            />
            <br>
          </div>

          <div
            v-if="loading"
            class="twobuttons"
          >
            <img
              src="/assets/images/loading.gif"
              style="width:200px;"
            >
          </div>
          <div
            v-else
            class="twobuttons"
          >
            <button class="button">
              Email me
            </button>
            <span>or</span>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'forgotten-password'}"
              custom
            >
              <button
                class="button clear custom-class"
                @click="navigate"
              >
                Reset password
              </button>
            </router-link>
          </div>
        </form>
      </div>
    </template>
    <template v-else>
      <h1>Login Link Sent</h1>

      <p>We've sent an email to {{ email }} with a secure link that you can use to instantly access your account.</p>

      <p>Please check your email account including your spam folder.</p>
    </template>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import {VueRecaptcha} from "vue-recaptcha";
import { useRoute } from 'vue-router';

export default {
    components: {
        VueRecaptcha
    },
    setup() {
        const route = useRoute();
        const email = ref(null);
        const loading = ref(false);
        const errors = ref([]);
        const sent = ref(false);
        const { recaptchaFields, resetCaptcha, recaptchaKey, first, recaptchaCompleted } = authComposable();

        const post = () => {
            loading.value = true;
            errors.value = [];

            const data = {
                email: email.value,
                recaptcha_response: recaptchaFields.response,
            };

            axios({
                method: 'post',
                url: '/auth/login-link',
                data: data,
            }).then(response => {
                if (response.data.success) {
                    sent.value = true;
                } else {
                    errors.value = response.data.errors;

                    if (errors.value.recaptcha_response) {
                        recaptchaFields.required = true;
                    }
                }

                loading.value = false;
            }).catch(error => {
                console.log(error);
                errors.value = { general: ['Something went wrong; please try again later.'] };
                loading.value = false;
            }).then(() => {
                resetCaptcha();
            });
        };

        onMounted(() => {
            if (route.query.email) {
                email.value = route.query.email;
            }
        });

        return {
            email,
            loading,
            errors,
            sent,
            post,
            recaptchaKey,
            first,
            recaptchaCompleted,
            recaptchaFields
        };
    },
};
</script>
